(() => {
  const root = document.getElementById("paths");
  const logo = root.querySelector(".logo .badge");
  const panels = [...root.querySelectorAll(".path")];

  const css = getComputedStyle(document.documentElement);
  const maxScale = parseFloat(css.getPropertyValue("--max-scale")) || 1.1;
  const shiftMax = parseFloat(css.getPropertyValue("--container-shift")) || 12;
  const logoShift = parseFloat(css.getPropertyValue("--logo-shift")) || 24;
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  requestAnimationFrame(() => {
    panels.forEach((p) => (p.style.transform = "scale(1) translateZ(0)"));
  });

  let mx = 0,
    my = 0,
    ticking = false;

  function isMobile() {
    return window.matchMedia("(max-width: 575px)").matches;
  }

  function scaleForPanel(r, mx, my) {
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = mx - cx,
      dy = my - cy;
    const dist = Math.hypot(dx, dy);
    const maxDist = Math.hypot(r.width, r.height) / 2;
    const t = clamp(dist / maxDist, 0, 1);
    return 1 + (1 - t) * (maxScale - 1);
  }

  function frame() {
    ticking = false;
    const r = root.getBoundingClientRect();

    // logo
    const nx = (mx - (r.left + r.width / 2)) / (r.width / 2);
    const ny = (my - (r.top + r.height / 2)) / (r.height / 2);
    logo.style.transform = `translate(${nx * logoShift}px, ${
      ny * logoShift
    }px) translateZ(0)`;

    // panels
    panels.forEach((p) => {
      const pr = p.getBoundingClientRect(); // ✅ fresh
      const sc = scaleForPanel(pr, mx, my);

      const oy = clamp(((my - pr.top) / pr.height) * 100, 0, 100);
      p.style.transformOrigin = p.classList.contains("left")
        ? `100% ${oy}%`
        : `0% ${oy}%`;

      const dx = (mx - (pr.left + pr.width / 2)) / (pr.width / 2);
      const dy = (my - (pr.top + pr.height / 2)) / (pr.height / 2);

      const tx = p.classList.contains("left")
        ? Math.min(0, dx) * shiftMax
        : Math.max(0, dx) * shiftMax;
      const ty = clamp(dy, -1, 1) * shiftMax;

      p.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${sc}) translateZ(0)`;
    });
  }

  root.addEventListener(
    "pointermove",
    (e) => {
      if (isMobile()) return;
      mx = e.clientX;
      my = e.clientY;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(frame);
      }
    },
    { passive: true }
  );

  root.addEventListener("mouseleave", () => {
    if (isMobile()) return;
    logo.style.transform = "";
    panels.forEach((p) => (p.style.transform = "scale(1) translateZ(0)"));
  });
})();
